import Enum from 'swift-enum'

import * as TaskCompletion from '../components/TaskCompletion'
import * as TaskHealth from '../components/TaskHealth'
import * as TaskStatus from '../components/TaskStatus'
import * as TaskCosts from '../components/TaskCosts'
import * as LookAhead from '../containers/LookAhead'
// import ScoreCard from '../components/ScoreCard'

class DashboardItem extends Enum {

  get parts() 
  {
    switch(this)
    {
      case DashboardItem.TaskCompletion: return TaskCompletion
      case DashboardItem.TaskHealth: return TaskHealth
      case DashboardItem.TaskStatus: return TaskStatus
      case DashboardItem.TaskCosts: return TaskCosts
      case DashboardItem.LookAhead: return LookAhead
      default: return null
    }
  }

  get title() 
  {
    switch(this)
    {
      case DashboardItem.TaskCompletion: return "Task Completion"
      case DashboardItem.TaskHealth: return "Task Health"
      case DashboardItem.TaskStatus: return "Task Status"
      case DashboardItem.TaskCosts: return "Task Costs"
      case DashboardItem.LookAhead: return "Look Ahead"
      default: return null
    }
  }
  
  get route()
  {
    return this.rawValue
  }

}

DashboardItem.case(
  'TaskStatus',  
  'LookAhead',
  'TaskCosts',  
  'TaskHealth',  
  'TaskCompletion'
  )
DashboardItem.freeze()

export default DashboardItem



// WEBPACK FOOTER //
// ./src/etc/dashboard-item.js